module.exports = __webpack_public_path__ + "media/luxury-2026/coastal-water-kitchen-960-1b52d548.jpg";